<div class="form-group" [class.has-error]="fieldErrors.primary || ((email.touched || email.dirty) && email.invalid)">
  <label for="member-edit-email">Email</label>
  <span *ngIf="unverified('primary')" id="primary-email-status" class="email-status">Not verified</span>
  <div class="email-input-row">
    <input type="email" class="form-control" id="member-edit-email" name="email"
      [(ngModel)]="primary.email" (ngModelChange)="clearFieldError('primary')"
      [ngModelOptions]="{standalone: true}" #email="ngModel" required email [readonly]="blocked"
      [attr.aria-invalid]="!!fieldErrors.primary || ((email.touched || email.dirty) && email.invalid)"
      aria-describedby="primary-email-error primary-email-status" />
    <select class="form-control email-category" aria-label="Email category"
      [(ngModel)]="primary.category" (ngModelChange)="clearFieldError('primary')"
      [ngModelOptions]="{standalone: true}" [disabled]="blocked">
      <option value="UNKNOWN">Not marked</option>
      <option value="PERSONAL">Personal</option>
      <option value="WORK">Work</option>
    </select>
  </div>
  <small id="primary-email-error" class="text-danger" role="alert"
    *ngIf="fieldErrors.primary || ((email.touched || email.dirty) && email.invalid)">
    {{ fieldErrors.primary || (primary.email ? 'Enter a valid email address.' : 'Enter an email address.') }}
  </small>
  <p *ngIf="pendingFor('primary')" class="text-muted email-pending">
    Pending replacement: {{ pending.email }}.
    <button type="button" class="btn btn-link" [disabled]="blocked" (click)="cancelPending()">Cancel replacement</button>
  </p>
</div>
<div class="form-group" [class.has-error]="fieldErrors.secondary || (secondary.email && (secondaryEmail.touched || secondaryEmail.dirty) && secondaryEmail.invalid)">
  <label for="member-edit-secondary-email">Secondary email</label>
  <span *ngIf="unverified('secondary')" id="secondary-email-status" class="email-status">Not verified</span>
  <div class="email-input-row">
    <input type="email" class="form-control" id="member-edit-secondary-email" name="secondaryEmail"
      [(ngModel)]="secondary.email" (ngModelChange)="clearFieldError('secondary')"
      [ngModelOptions]="{standalone: true}" #secondaryEmail="ngModel" email [readonly]="blocked"
      [attr.aria-invalid]="!!fieldErrors.secondary || (!!secondary.email && (secondaryEmail.touched || secondaryEmail.dirty) && secondaryEmail.invalid)"
      aria-describedby="secondary-email-error secondary-email-status" />
    <select class="form-control email-category" aria-label="Secondary email category"
      [(ngModel)]="secondary.category" (ngModelChange)="clearFieldError('secondary')"
      [ngModelOptions]="{standalone: true}" [disabled]="blocked">
      <option value="UNKNOWN">Not marked</option>
      <option value="PERSONAL">Personal</option>
      <option value="WORK">Work</option>
    </select>
  </div>
  <small id="secondary-email-error" class="text-danger" role="alert"
    *ngIf="fieldErrors.secondary || (secondary.email && (secondaryEmail.touched || secondaryEmail.dirty) && secondaryEmail.invalid)">
    {{ fieldErrors.secondary || 'Enter a valid email address.' }}
  </small>
  <p *ngIf="pendingFor('secondary')" class="text-muted email-pending">
    Pending replacement: {{ pending.email }}.
    <button type="button" class="btn btn-link" [disabled]="blocked" (click)="cancelPending()">Cancel replacement</button>
  </p>
</div>
<p *ngIf="error" class="text-danger" role="alert">{{ error }}</p>



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/member/member-email-settings/member-email-settings.component.html